const MC_0653_BANNER_UPGRADE_KEY = 'mc-0653-banner';
const MC_0653_SENDS_COUNTER_UPGRADE_KEY = 'mc-0653-email-sends-counter';
const MC_0653_SENDING_OPTIONS_UPGRADE_KEY = 'mc-0653-sending-options';
const MC_0653_UPGRADE_KEYS_LIST = [MC_0653_BANNER_UPGRADE_KEY, MC_0653_SENDS_COUNTER_UPGRADE_KEY, MC_0653_SENDING_OPTIONS_UPGRADE_KEY];
export const isMc0653UpgradeKey = upgradeKey => MC_0653_UPGRADE_KEYS_LIST.includes(upgradeKey);